export function getSpecificationColumns(variants = []) {
    const columns = [];
    const displayNames = new Set();

    for (const variant of variants || []) {
        for (const attribute of variant?.Attributes || []) {
            if (!attribute.IsSpecification) continue;

            const displayName = attribute.AttributeDisplayName || attribute.AttributeName;

            if (!displayName || displayNames.has(displayName)) continue;

            displayNames.add(displayName);
            columns.push({
                Attribute: attribute.AttributeName,
                AttributeDisplayName: displayName,
            });
        }
    }

    return columns;
}
